import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { useCountry } from "src/client/js/view/hooks";
import { localiseUrlII } from "src/common/utils/format-localised-url";

const ShopNavigationItem = ({ title, columns, image, active, onMouseOver }) => {
  const country = useCountry();

  return (
    <li
      className="ShopNavigation__nav-item"
      active={active}
      onMouseOver={onMouseOver}
    >
      <div className="ShopNavigation__nav-item-title">
        {active && (
          <svg
            width="35"
            height="22"
            viewBox="0 0 35 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.0363851 0.145058L26.5095 0.145057C26.7099 0.145057 26.8983 0.236594 27.0175 0.392464L34.8754 10.6355C35.0415 10.8522 35.0415 11.1484 34.8754 11.3647L27.0175 21.6073C26.8983 21.7628 26.7095 21.8547 26.5095 21.8547L0.0363861 21.8547C0.0363861 21.8547 -0.0454834 2.53241 0.0363851 0.145058Z"
              fill="#6AB5F4"
            />
          </svg>
        )}
        <span
          className={cx("ShopNavigation__text", {
            "ShopNavigation__text--active": active,
          })}
        >
          {title}
        </span>
      </div>
      {active && (
        <div className="ShopNavigation__nav-container">
          {columns?.map(({ id, items }) => {
            return (
              <ul key={id} className="ShopNavigation__secondary-list">
                {items.map(({ navLinkLabel, navLinkUrl }) => {
                  return (
                    <li
                      key={navLinkLabel}
                      className="ShopNavigation__link-item"
                    >
                      <a
                        className="ShopNavigation__nav-link"
                        href={localiseUrlII(country, navLinkUrl)}
                      >
                        {navLinkLabel}
                      </a>
                    </li>
                  );
                })}
              </ul>
            );
          })}
        </div>
      )}
    </li>
  );
};

ShopNavigationItem.propTypes = {
  title: PropTypes.string,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          navLinkLabel: PropTypes.string.isRequired,
          navLinkUrl: PropTypes.string.isRequired,
        })
      ),
    })
  ),
  image: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string,
  }),
  active: PropTypes.bool,
  onMouseOver: PropTypes.func,
};

export default ShopNavigationItem;
